import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import {
  CustomQuery
} from '@vue-storefront/core';
// import { useApiError } from '../useApiError';

export const useUserShouHouList = (id: string): any => {
  // const { set: setError } = useApiError();
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("useConfigcontext---------", context.useApiError);
  // Shared ref holding the response from the API
  const List = sharedRef([], `useUserShouHouList-${id}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useUserShouHouList-loading-${id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `useUserShouHouList-error-${id}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const shouhouGet = async (params: CustomQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.salesOrderList(params);
      // console.log('售后查询-------------------shouhouGet', params, res)
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        List.value = res?.data?.data;
        error.value = null;
      } else {
        // setError(res);
        error.value = new Error(res.message);
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };
  return {
    shouhouGet: shouhouGet,
    aftersalesList: computed(() => List.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
